/**
 * A singleton class that manages a queue of asynchronous tasks.
 *
 * Tasks are executed one at a time in the order they are enqueued.
 * Each task has a default timeout of DEFAULT_TIMEOUT seconds.
 */
export class AsyncTaskQueueManager {
    static _instance;
    static _DEFAULT_TIMEOUT = 10000;
    _queue = [];
    _isRunning = false;
    constructor() { }
    static getInstance() {
        if (!AsyncTaskQueueManager._instance) {
            AsyncTaskQueueManager._instance = new AsyncTaskQueueManager();
        }
        return AsyncTaskQueueManager._instance;
    }
    static async enqueue(task) {
        return AsyncTaskQueueManager.getInstance().enqueueTask(task);
    }
    async enqueueTask(task) {
        return new Promise((resolve, reject) => {
            const wrappedTask = async () => {
                try {
                    const result = await this._withTimeout(task, AsyncTaskQueueManager._DEFAULT_TIMEOUT);
                    resolve(result);
                }
                catch (err) {
                    console.error("Async task failed or timed out:", err);
                    reject(err);
                }
            };
            this._queue.push(wrappedTask);
            this._runQueue();
        });
    }
    async _runQueue() {
        if (this._isRunning)
            return;
        this._isRunning = true;
        while (this._queue.length > 0) {
            const task = this._queue.shift();
            if (task) {
                await task();
            }
        }
        this._isRunning = false;
    }
    async _withTimeout(taskFn, ms) {
        const controller = new AbortController();
        const { signal } = controller;
        return new Promise((resolve, reject) => {
            const timeoutId = setTimeout(() => {
                controller.abort();
                reject(new Error(`Task timed out after ${ms}ms`));
            }, ms);
            taskFn(signal)
                .then(resolve)
                .catch(reject)
                .finally(() => clearTimeout(timeoutId));
        });
    }
}
//# sourceMappingURL=asyncTaskQueueManager.js.map